import * as React from "react";
import { ThemeProvider as FluentThemeProvider, FocusRectsProvider } from "@fluentui/react";
import { themeFor } from "./themes";
import { useThemePreference } from "./useThemePreference";

export const ThemeProviderShell: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { effective } = useThemePreference();
  // @fluentui/react@8.87.2's ThemeProvider unconditionally reads
  // `useContext(FocusRectsContext).providerRef` with no ancestor Provider,
  // which throws ("Cannot read properties of undefined (reading
  // 'providerRef')") the moment it mounts at the top of the tree. Supplying a
  // FocusRectsProvider here avoids the crash; passing the same ref to both
  // keeps focus-rect scoping tied to this element instead of the default
  // window-level fallback.
  const providerRef = React.useRef<HTMLElement | null>(null);
  return (
    <FocusRectsProvider providerRef={providerRef}>
      <FluentThemeProvider
        ref={providerRef}
        theme={themeFor(effective)}
        applyTo="element"
        style={{ height: "100%", width: "100%" }}
      >
        {children}
      </FluentThemeProvider>
    </FocusRectsProvider>
  );
};
